// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgFriendsOfFriends: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M2.001 19.073a.1.1 0 0 0 .023.045H13.53m.017-.022c-.26-.899-.764-2.068-1.668-3.002-.885-.915-2.19-1.648-4.179-1.648-1.985 0-3.25.73-4.096 1.635-.862.922-1.336 2.077-1.602 2.992m.141-4.358c1.212-1.295 3-2.268 5.557-2.268 2.555 0 4.372.97 5.616 2.256 1.219 1.259 1.85 2.777 2.16 3.863.341 1.196-.552 2.552-1.956 2.552H2.021c-1.451 0-2.24-1.412-1.964-2.52l.004-.016.005-.016C.37 17.5.96 15.98 2.142 14.716"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M17.494 15.724c-.423 0-.87.106-1.46.254a1 1 0 1 1-.44-1.952c.537-.134 1.208-.302 1.9-.302 2.042 0 3.534.746 4.568 1.758 1.011.99 1.545 2.194 1.791 3.096.162.594-.027 1.181-.311 1.585-.293.416-.814.814-1.505.814H17.92a1 1 0 1 1 0-2h3.967c-.194-.64-.576-1.43-1.224-2.066-.67-.655-1.662-1.187-3.169-1.187"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M7.7 5a2.407 2.407 0 1 0 0 4.814A2.407 2.407 0 0 0 7.7 5M3.293 7.407a4.407 4.407 0 1 1 8.814 0 4.407 4.407 0 0 1-8.814 0"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M17.352 7.84a1.697 1.697 0 1 0 0 3.394 1.697 1.697 0 0 0 0-3.394m-3.697 1.697a3.697 3.697 0 1 1 7.394 0 3.697 3.697 0 0 1-7.394 0"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgFriendsOfFriends);
export default Memo;
